import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NSSkeletonModule } from '@norfolk-southern/accessns-components';

import { UTFiltersFormModule } from '@ruby/modules/unit-train/submodules/ut-filters-form/ut-filters-form.module';
import { UTResultsMapComponent } from '@ruby/modules/unit-train/submodules/ut-map/components/ut-results-map/ut-results-map.component';
import { UTResultsMapContainer } from '@ruby/modules/unit-train/submodules/ut-map/containers/ut-results-map/ut-results-map.container';
import { UTMapRoutingModule } from '@ruby/modules/unit-train/submodules/ut-map/ut-map-routing.module';
import { CTMSMapModule } from '@ruby/shared/components/ctms-map/ctms-map.module';
import { PermitDetailModule } from '@ruby/shared/dialogs/unit-train/permit-detail/permit-detail.module';
import { TrainConsistModule } from '@ruby/shared/dialogs/unit-train/train-consist/train-consist.module';

@NgModule({
  declarations: [
    UTResultsMapContainer,
    UTResultsMapComponent
  ],
  exports: [
    UTResultsMapContainer
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    MatTooltipModule,
    MatToolbarModule,
    PermitDetailModule,
    TrainConsistModule,
    UTMapRoutingModule,
    NSSkeletonModule,
    UTFiltersFormModule,
    CTMSMapModule
  ]
})
export class UTMapModule {}
